import { defineStore } from "pinia";
import { ref, watch } from "vue";

const ISTEINGEKLAPPT_KEY = 'isteingeklappt';

const getGespeicherterEinklappStatus = (): boolean | null => {
    const gespeicherterEinklappStatus = localStorage.getItem(ISTEINGEKLAPPT_KEY);
    return gespeicherterEinklappStatus !== null ? JSON.parse(gespeicherterEinklappStatus) : null;
};

export const useSidebarStore = defineStore('sidebar', () => {
    const istEingeklappt = ref<boolean>(getGespeicherterEinklappStatus() ?? false);
    
    // Watch for changes to persist in localStorage
    watch(istEingeklappt, (newValue) => {
        localStorage.setItem(ISTEINGEKLAPPT_KEY, JSON.stringify(newValue));
    });

    return {
        istEingeklappt
    };
});